import { createAction } from '@reduxjs/toolkit';

import { PromoOfferState, SET_PROMO_OFFER } from './types';

export const setPromoOffer = createAction<PromoOfferState, typeof SET_PROMO_OFFER>(SET_PROMO_OFFER);
